import { ComponentIds } from '@inter-ikea-core/core';
import { PlannerEcsMultiSystem } from './System';
export class SelectionEventSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'SelectionEventSystem', [
            ComponentIds.SELECTED_COMPONENT_ID,
            ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID
        ]);
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === ComponentIds.SELECTED_COMPONENT_ID) {
            this.onSelectionAdded(entity);
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        switch (oldComponent.typeId) {
            case ComponentIds.SELECTED_COMPONENT_ID: {
                this.onSelectionRemoved(entity);
                break;
            }
            case ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID: {
                this.onDragStop();
                break;
            }
        }
    }
    onSelectionAdded(entity) {
        const currentlyDraggedEntities = this.coreApi.entities.getByComponent(ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID);
        if (currentlyDraggedEntities.length > 0)
            return;
        this.coreApi.emit.onSelected(this.coreApi.entities.findProductEntity(entity.id));
    }
    onSelectionRemoved(entity) {
        const entities = this.coreApi.entities.getByComponent(ComponentIds.SOMETHING_IS_DRAGGED_COMPONENT_ID);
        if (entities.length > 0)
            return;
        const selectedEntities = this.coreApi.entities.getByComponent(ComponentIds.SELECTED_COMPONENT_ID);
        if (selectedEntities.length > 0)
            return;
        const product = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID);
        if (product?.productRef) {
            this.coreApi.emit.onDeselected({
                entityId: entity.id,
                productId: product.productRef
            });
        }
    }
    onDragStop() {
        const entities = this.coreApi.entities.getByComponent(ComponentIds.SELECTED_COMPONENT_ID);
        if (entities.length === 1) {
            this.coreApi.emit.onSelected(this.coreApi.entities.findProductEntity(entities[0].id));
        }
    }
}
//# sourceMappingURL=SelectionEventSystem.js.map